"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Modal_1 = __importDefault(require("react-modal/lib/components/Modal")); // Import only the Modal component
const styled_components_1 = require("styled-components");
const styles_styled_1 = require("./styles.styled");
const SsoHeader_1 = __importDefault(require("../SsoHeader"));
const helpers_1 = require("../../helpers");
const SsoBottomLinks_1 = __importDefault(require("../SsoBottomLinks"));
const constants_1 = require("../../constants");
const CustomModal = ({ children, open, onClose, width, isFullScreen = false, isBottom = false, modalKey, withLayout = true, setIsSsoModalOpen, isNested = false, }) => {
    const { isMobile, isDesktop } = (0, styled_components_1.useTheme)();
    (0, react_1.useEffect)(() => {
        if (isMobile &&
            (0, helpers_1.isBrowser)() &&
            typeof navigator !== "undefined" &&
            (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent.includes("iPhone"))) {
            let prevScrollPosition = window.scrollY;
            if (!isNested) {
                if (open) {
                    prevScrollPosition = window.scrollY;
                    document.querySelector("html").style.overflow = "hidden";
                    document.querySelector("html").style.height = "100%";
                    document.body.style.height = "100%";
                }
                else {
                    document.querySelector("html").removeAttribute("style");
                    document.body.removeAttribute("style");
                    window.scrollTo(0, prevScrollPosition);
                }
                return () => {
                    document.querySelector("html").removeAttribute("style");
                    document.body.removeAttribute("style");
                    window.scrollTo(0, prevScrollPosition);
                };
            }
        }
    }, [open]);
    const modalStyle = {
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 99999999
        },
        content: {
            width: isBottom ? "100%" : width,
            top: !isBottom && !isFullScreen ? "50%" : (isBottom ? "unset" : 0),
            left: !isBottom && !isFullScreen ? "50%" : 0,
            right: !isBottom && !isFullScreen ? "unset" : 0,
            bottom: !isBottom && !isFullScreen ? "unset" : 0,
            transform: !isBottom && !isFullScreen ? "translate(-50%, -50%)" : "unset",
            maxWidth: isFullScreen || isBottom ? "100%" : "90%",
            maxHeight: isFullScreen ? "100%" : "90%",
            border: "none",
            background: "none",
            overflow: isDesktop && !isFullScreen ? "initial" : "auto",
            WebkitOverflowScrolling: "touch",
            outline: "none",
            padding: 0,
            fontSize: "16px",
            backgroundColor: "#fff",
            boxShadow: "rgba(0, 0, 0, 0.2) 0px 11px 15px -7px, rgba(0, 0, 0, 0.14) 0px 24px 38px 3px, rgba(0, 0, 0, 0.12) 0px 9px 46px 8px",
            borderRadius: !isFullScreen && !isBottom
                ? "8px"
                : isBottom
                    ? "20px 20px 0 0"
                    : "unset",
        },
    };
    return ((0, jsx_runtime_1.jsx)(Modal_1.default, Object.assign({ isOpen: open, onRequestClose: onClose, contentLabel: "Modal", style: modalStyle, bodyOpenClassName: "overflowHidden overflow-hidden" }, { children: (0, jsx_runtime_1.jsx)(styles_styled_1.SsoWrapper, Object.assign({}, (0, helpers_1.classNames)(isFullScreen && !isBottom && "fullScreenHeight"), { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({}, (0, helpers_1.classNames)(isFullScreen &&
                "flex flexDirectionColumn alignItems flexSpaceBetween justifyContent", isMobile && "grayBg", !isBottom && isFullScreen && "height-100"), { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({}, (0, helpers_1.classNames)(isFullScreen && "width-100"), { children: [withLayout && !isBottom && ((0, jsx_runtime_1.jsx)(SsoHeader_1.default, { setIsSsoModalOpen: setIsSsoModalOpen })), children] })), isFullScreen && withLayout && !isBottom && modalKey !== constants_1.ScreenConstants.LOGIN_SCREEN && (0, jsx_runtime_1.jsx)(SsoBottomLinks_1.default, {})] })) })) }), modalKey));
};
exports.default = CustomModal;
